import React, { useEffect, useState } from "react";
import { getConsent, setConsent, loadClarity, loadCrisp, loadGA, updateGAConsent, captureRef } from "@/lib/clarity";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    captureRef();
    loadGA(); // Consent Mode v2: gtag loads with denied defaults (never on /admin or admins).
    const c = getConsent();
    if (c === "accepted") { updateGAConsent(true); loadClarity(); loadCrisp(); return; }
    if (!c) setVisible(true);
  }, []);

  const accept = () => {
    setConsent("accepted");
    updateGAConsent(true);
    loadClarity();
    loadCrisp();
    setVisible(false);
  };
  const refuse = () => {
    setConsent("refused");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner" data-testid="cookie-banner" role="dialog" aria-label="Consentement aux cookies">
      <p className="cookie-banner-text">
        On utilise des cookies pour analyser et améliorer ton expérience.
        <a href="/mentions-legales" className="accent"> En savoir plus</a>.
      </p>
      <div className="cookie-banner-actions">
        <button onClick={refuse} data-testid="cookie-refuse" className="btn-secondary btn-small">Refuser</button>
        <button onClick={accept} data-testid="cookie-accept" className="btn-primary btn-small">Accepter</button>
      </div>
    </div>
  );
};
